import api from "./api";
import type {
  Notification,
  NotificationListResponse,
  NotificationSetting,
  NotificationSettingUpdate,
  NotificationFilters,
  DndSetting,
  DndSettingUpdate,
} from "@/types/notification";

export const notificationService = {
  // 알림 목록 조회
  async getNotifications(
    params?: NotificationFilters
  ): Promise<NotificationListResponse> {
    const response = await api.get<NotificationListResponse>("/notifications", {
      params,
    });
    return response.data;
  },

  // 읽지 않은 알림 수 조회
  async getUnreadCount(): Promise<{ count: number }> {
    const response = await api.get<{ count: number }>(
      "/notifications/unread-count"
    );
    return response.data;
  },

  // 알림 읽음 처리
  async markAsRead(notificationId: number): Promise<Notification> {
    const response = await api.post<Notification>(
      `/notifications/${notificationId}/read`
    );
    return response.data;
  },

  // 모든 알림 읽음 처리
  async markAllAsRead(): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>(
      "/notifications/read-all"
    );
    return response.data;
  },

  // 특정 채팅방 알림 읽음 처리
  async markChatRoomAsRead(roomId: number): Promise<{ message: string }> {
    const response = await api.post<{ message: string }>(
      `/notifications/read-chat/${roomId}`
    );
    return response.data;
  },

  // 알림 삭제
  async deleteNotification(notificationId: number): Promise<void> {
    await api.delete(`/notifications/${notificationId}`);
  },

  // 알림 설정 조회
  async getSettings(): Promise<NotificationSetting[]> {
    const response = await api.get<NotificationSetting[]>(
      "/notifications/settings"
    );
    return response.data;
  },

  // 알림 설정 업데이트
  async updateSetting(
    data: NotificationSettingUpdate
  ): Promise<NotificationSetting> {
    const response = await api.put<NotificationSetting>(
      "/notifications/settings",
      data
    );
    return response.data;
  },

  // 방해금지 설정 조회
  async getDndSetting(): Promise<DndSetting> {
    const response = await api.get<DndSetting>("/notifications/dnd");
    return response.data;
  },

  // 방해금지 설정 업데이트
  async updateDndSetting(data: DndSettingUpdate): Promise<DndSetting> {
    const response = await api.put<DndSetting>("/notifications/dnd", data);
    return response.data;
  },
};

export default notificationService;
